import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneLight } from 'react-syntax-highlighter/dist/esm/styles/prism';

import { CopyToClipboard } from '../../legacy-components/copy-to-clipboard-v2';

import { ReactNode } from 'react';
import './code-scrollbar.css';
import React from 'react';

export const languageMap = (lang: string) => {
  switch (lang) {
    case 'terraform':
    case 'ruby':
      return 'hcl';
    default:
      return lang;
  }
};

export const CustomCodeBlock = React.memo<{
  className?: string;
  children?: ReactNode;
}>(
  (props) => {
    const { children, className } = props;
    const providedLang =
      /lang-(\w+)/.exec(className || '')?.[1] ||
      /language-(\w+)/.exec(className || '')?.[1] ||
      '';

    const language = languageMap(providedLang) || 'shell';

    const isInline =
      !providedLang && typeof children === 'string' && !children.includes('\n');

    const code = String(children).replace(/\n$/, '');

    return !isInline ? (
      <div className="border-light-gray bg-background-container relative w-full overflow-hidden rounded-lg border duration-200">
        <div className="w-full">
          <div className="border-light-gray bg-background-tabs flex w-full items-center justify-between border-b px-4 py-3">
            <div className="flex items-center gap-3">
              <div className="flex items-center gap-2">
                <span className="text-content-muted font-mono text-xs font-medium">
                  {language}
                </span>
              </div>
            </div>
            <CopyToClipboard
              value={code}
              className="text-content-muted transform transition-all duration-200 hover:scale-105 hover:text-black dark:hover:text-white"
            />
          </div>
          <div className="code-scrollbar overflow-auto p-4">
            <SyntaxHighlighter
              {...props}
              className="!m-0"
              style={{
                ...oneLight,
                'pre[class*="language-"]': {
                  background: 'transparent',
                  margin: 0,
                  padding: 0,
                },
              }}
              language={language || 'bash'}
              wrapLongLines={false}
              PreTag="div"
              codeTagProps={{
                className:
                  'font-mono selection:bg-zinc-700/30 text-sm leading-relaxed',
              }}
              showLineNumbers={false}
            >
              {String(code).replace(/\n$/, '')}
            </SyntaxHighlighter>
          </div>
        </div>
      </div>
    ) : (
      <code
        {...props}
        className={`${className} bg-background-container border-light-gray hover:bg-background-hover hover:border-border-hover rounded-md border px-2 py-0.5 font-mono text-sm text-black dark:text-white shadow-sm transition-colors duration-200`}
      >
        {children}
      </code>
    );
  },
  (prevProps, nextProps) => {
    return prevProps.children === nextProps.children;
  },
);
